// extracted by mini-css-extract-plugin
module.exports = {"outer":"Recaptcha_outer__oAC23","errorsBox":"Recaptcha_errorsBox__3oDAl"};